const pageLayoutBaseClasses = ["page-layout", "shell"] as const;

function classTokens(classes: Array<string | false | null | undefined>) {
  return classes.flatMap((value) => typeof value === "string" ? value.split(/\s+/) : []).filter(Boolean);
}

export function pageShellClassName(...classes: Array<string | false | null | undefined>) {
  return [...new Set([...pageLayoutBaseClasses, ...classTokens(classes)])].join(" ");
}

export function pageFrameClassName(...classes: Array<string | false | null | undefined>) {
  return [...new Set(["page-layout", ...classTokens(classes)])].join(" ");
}

export function pageHeroClassName(...classes: Array<string | false | null | undefined>) {
  return [...new Set(["page-hero", "wide-page-hero", ...classTokens(classes)])].join(" ");
}
